


// // // // // import React, { useContext, useState } from 'react';
// // // // // import { Link as RouterLink, useNavigate } from 'react-router-dom';
// // // // // import {
// // // // //   Grid,
// // // // //   Paper,
// // // // //   Typography,
// // // // //   TextField,
// // // // //   CircularProgress,
// // // // //   Box,
// // // // //   styled,
// // // // //   IconButton,
// // // // //   InputAdornment,
// // // // //   FormControlLabel,
// // // // //   Checkbox,
// // // // // } from '@mui/material';
// // // // // import { createTheme, ThemeProvider } from '@mui/material/styles';
// // // // // import { LightPurpleButton } from '../components/buttonStyles';
// // // // // import { AuthContext } from './context/AuthContext';
// // // // // import { Visibility, VisibilityOff } from '@mui/icons-material';

// // // // // // Import background image (replace with your actual image import)
// // // // // import bgpic from "../assets/designlogin.jpg";

// // // // // const defaultTheme = createTheme();

// // // // // const StyledLink = styled(RouterLink)(({ theme }) => ({
// // // // //   color: theme.palette.primary.main,
// // // // //   textDecoration: 'none',
// // // // //   '&:hover': {
// // // // //     textDecoration: 'underline',
// // // // //   },
// // // // // }));

// // // // // const LoginPage = () => {
// // // // //   const { loginByPassword, sendOTP } = useContext(AuthContext);
// // // // //   const navigate = useNavigate();

// // // // //   const [toggle, setToggle] = useState(false);

// // // // //   const [emailError, setEmailError] = useState(false);
// // // // //   const [passwordError, setPasswordError] = useState(false);
// // // // //   const [otpMode, setOtpMode] = useState(false);
// // // // //   const [email, setEmail] = useState('');
// // // // //   const [password, setPassword] = useState('');
// // // // //   const [otpEmail, setOtpEmail] = useState('');
// // // // //   const [emailForOtp, setEmailForOtp] = useState('');

// // // // //   const handleSubmit = async (event) => {
// // // // //     event.preventDefault();

// // // // //     if (otpMode) {
// // // // //       // Handle OTP submission logic
// // // // //       if (!emailForOtp) {
// // // // //         setEmailError(true);
// // // // //         return;
// // // // //       }
// // // // //       const success = await sendOTP(emailForOtp);

// // // // //     } else {
// // // // //       // Regular email/password login
// // // // //       if (!email || !password) {
// // // // //         if (!email) setEmailError(true);
// // // // //         if (!password) setPasswordError(true);
// // // // //         return;
// // // // //       }

// // // // //       const success = await loginByPassword(email, password);


// // // // //     }
// // // // //   };

// // // // //   const handleInputChange = (event) => {
// // // // //     const { name, value } = event.target;
// // // // //     if (name === 'email') {
// // // // //       setEmail(value);
// // // // //       setEmailError(false);
// // // // //     }
// // // // //     if (name === 'password') {
// // // // //       setPassword(value);
// // // // //       setPasswordError(false);
// // // // //     }
// // // // //     if (name === 'emailForOtp') {
// // // // //       setEmailForOtp(value);
// // // // //       setEmailError(false);
// // // // //     }
// // // // //   };

// // // // //   const toggleVisibility = () => {
// // // // //     setToggle(!toggle);
// // // // //   };

// // // // //   const switchToOTPMode = () => {
// // // // //     setOtpMode(true);
// // // // //     setEmailError(false); // Reset email error state
// // // // //     setPasswordError(false); // Reset password error state
// // // // //   };

// // // // //   return (
// // // // //     <ThemeProvider theme={defaultTheme}>
// // // // //       <Grid container component="main" sx={{ height: '100vh' }}>
// // // // //         <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
// // // // //           <Box
// // // // //             sx={{
// // // // //               my: 8,
// // // // //               mx: 4,
// // // // //               display: 'flex',
// // // // //               flexDirection: 'column',
// // // // //               alignItems: 'center',
// // // // //             }}
// // // // //           >
// // // // //             <Typography variant="h4" sx={{ mb: 2, color: "#2c2143" }}>
// // // // //               {otpMode ? "OTP Login" : "User Login"}
// // // // //             </Typography>
// // // // //             <Typography variant="subtitle1" sx={{ mb: 1 }}>
// // // // //               {otpMode
// // // // //                 ? "Please enter your registered email to receive OTP."
// // // // //                 : "Welcome back! Please enter your details."}
// // // // //             </Typography>
// // // // //             <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 2 }}>
// // // // //               {!otpMode && (
// // // // //                 <TextField
// // // // //                   margin="normal"
// // // // //                   required
// // // // //                   fullWidth
// // // // //                   id="email"
// // // // //                   label="Enter your email"
// // // // //                   name="email"
// // // // //                   autoComplete="email"
// // // // //                   autoFocus
// // // // //                   error={emailError}
// // // // //                   helperText={emailError && 'Email is required'}
// // // // //                   value={email}
// // // // //                   onChange={handleInputChange}
// // // // //                 />
// // // // //               )}
// // // // //               {!otpMode && (
// // // // //                 <TextField
// // // // //                   margin="normal"
// // // // //                   required
// // // // //                   fullWidth
// // // // //                   name="password"
// // // // //                   label="Password"
// // // // //                   type={toggle ? 'text' : 'password'}
// // // // //                   id="password"
// // // // //                   autoComplete="current-password"
// // // // //                   error={passwordError}
// // // // //                   helperText={passwordError && 'Password is required'}
// // // // //                   value={password}
// // // // //                   onChange={handleInputChange}
// // // // //                   InputProps={{
// // // // //                     endAdornment: (
// // // // //                       <InputAdornment position="end">
// // // // //                         <IconButton onClick={toggleVisibility}>
// // // // //                           {toggle ? (
// // // // //                             <Visibility />
// // // // //                           ) : (
// // // // //                             <VisibilityOff />
// // // // //                           )}
// // // // //                         </IconButton>
// // // // //                       </InputAdornment>
// // // // //                     ),
// // // // //                   }}
// // // // //                 />
// // // // //               )}

// // // // //               {!otpMode && (
// // // // //                 <Grid container sx={{ display: "flex", justifyContent: "space-between" }}>
// // // // //                   <FormControlLabel
// // // // //                     control={<Checkbox value="remember" color="primary" />}
// // // // //                     label="Remember me"
// // // // //                   />
// // // // //                   <StyledLink to="#">
// // // // //                     Forgot your password?
// // // // //                   </StyledLink>
// // // // //                 </Grid>
// // // // //               )}

// // // // //               {otpMode && (
// // // // //                 <TextField
// // // // //                   margin="normal"
// // // // //                   required
// // // // //                   fullWidth
// // // // //                   id="emailForOtp"
// // // // //                   label="Enter your registered email"
// // // // //                   name="emailForOtp"
// // // // //                   autoComplete="email"
// // // // //                   autoFocus
// // // // //                   error={emailError}
// // // // //                   helperText={emailError && 'Email is required'}
// // // // //                   value={emailForOtp}
// // // // //                   onChange={handleInputChange}
// // // // //                 />
// // // // //               )}
// // // // //               {otpMode && (
// // // // //                 <LightPurpleButton
// // // // //                   fullWidth
// // // // //                   variant="contained"
// // // // //                   sx={{ mt: 2 }}
// // // // //                   onClick={handleSubmit}
// // // // //                 >
// // // // //                   Send OTP
// // // // //                 </LightPurpleButton>
// // // // //               )}
// // // // //               {!otpMode && (
// // // // //                 <LightPurpleButton
// // // // //                   type="submit"
// // // // //                   fullWidth
// // // // //                   variant="contained"
// // // // //                   sx={{ mt: 3 }}
// // // // //                 >

// // // // //                     Login
// // // // //                 </LightPurpleButton>
// // // // //               )}
// // // // //               {!otpMode && (
// // // // //                 <Grid container sx={{ display: "flex", justifyContent: "space-between", marginTop: "7px" }}>
// // // // //                   <StyledLink to="#" onClick={switchToOTPMode}>
// // // // //                     Try another way to login?
// // // // //                   </StyledLink>
// // // // //                 </Grid>
// // // // //               )}
// // // // //             </Box>
// // // // //           </Box>
// // // // //         </Grid>
// // // // //         <Grid
// // // // //           item
// // // // //           xs={false}
// // // // //           sm={4}
// // // // //           md={7}
// // // // //           sx={{
// // // // //             backgroundImage: `url(${bgpic})`,
// // // // //             backgroundRepeat: 'no-repeat',
// // // // //             backgroundColor: (t) =>
// // // // //               t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
// // // // //             backgroundSize: 'cover',
// // // // //             backgroundPosition: 'center',
// // // // //           }}
// // // // //         />
// // // // //       </Grid>
// // // // //     </ThemeProvider>
// // // // //   );
// // // // // };

// // // // // export default LoginPage;


// // // // import React, { useContext, useState } from 'react';
// // // // import { Link as RouterLink, useNavigate } from 'react-router-dom';
// // // // import {
// // // //   Grid,
// // // //   Paper,
// // // //   Typography,
// // // //   TextField,
// // // //   CircularProgress,
// // // //   Box,
// // // //   styled,
// // // //   IconButton,
// // // //   InputAdornment,
// // // //   FormControlLabel,
// // // //   Checkbox,
// // // //   Dialog,
// // // //   DialogActions,
// // // //   DialogContent,
// // // //   DialogTitle,
// // // //   Button,
// // // //   FormControl,
// // // //   InputLabel,
// // // //   Select,
// // // //   MenuItem,
// // // // } from '@mui/material';
// // // // import { createTheme, ThemeProvider } from '@mui/material/styles';
// // // // import { LightPurpleButton } from '../components/buttonStyles';
// // // // import { AuthContext } from './context/AuthContext';
// // // // import { Visibility, VisibilityOff } from '@mui/icons-material';
// // // // import bgpic from "../assets/designlogin.jpg";

// // // // const defaultTheme = createTheme();

// // // // const StyledLink = styled(RouterLink)(({ theme }) => ({
// // // //   color: theme.palette.primary.main,
// // // //   textDecoration: 'none',
// // // //   '&:hover': {
// // // //     textDecoration: 'underline',
// // // //   },
// // // // }));

// // // // const LoginPage = () => {
// // // //   const { loginByPassword, sendOTP, sendForgotPasswordEmail } = useContext(AuthContext);
// // // //   const navigate = useNavigate();

// // // //   const [toggle, setToggle] = useState(false);
// // // //   const [emailError, setEmailError] = useState(false);
// // // //   const [passwordError, setPasswordError] = useState(false);
// // // //   const [otpMode, setOtpMode] = useState(false);
// // // //   const [email, setEmail] = useState('');
// // // //   const [password, setPassword] = useState('');
// // // //   const [forgotPasswordOpen, setForgotPasswordOpen] = useState(false);
// // // //   const [forgotPasswordEmail, setForgotPasswordEmail] = useState('');
// // // //   const [userType, setUserType] = useState('');

// // // //   const handleSubmit = async (event) => {
// // // //     event.preventDefault();
// // // //     if (otpMode) {
// // // //       if (!email) {
// // // //         setEmailError(true);
// // // //         return;
// // // //       }
// // // //       await sendOTP(email);
// // // //     } else {
// // // //       if (!email || !password) {
// // // //         if (!email) setEmailError(true);
// // // //         if (!password) setPasswordError(true);
// // // //         return;
// // // //       }
// // // //       await loginByPassword(email, password);
// // // //     }
// // // //   };

// // // //   const handleForgotPassword = async () => {
// // // //     if (!forgotPasswordEmail || !userType) {
// // // //       setEmailError(true);
// // // //       return;
// // // //     }
// // // //     await sendForgotPasswordEmail(forgotPasswordEmail, userType);
// // // //     setForgotPasswordOpen(false);
// // // //     setForgotPasswordEmail('');
// // // //     setUserType('');
// // // //   };

// // // //   const toggleVisibility = () => {
// // // //     setToggle(!toggle);
// // // //   };

// // // //   const switchToOTPMode = () => {
// // // //     setOtpMode(true);
// // // //     setEmailError(false);
// // // //     setPasswordError(false);
// // // //   };

// // // //   return (
// // // //     <ThemeProvider theme={defaultTheme}>
// // // //       <Grid container component="main" sx={{ height: '100vh' }}>
// // // //         <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
// // // //           <Box
// // // //             sx={{
// // // //               my: 8,
// // // //               mx: 4,
// // // //               display: 'flex',
// // // //               flexDirection: 'column',
// // // //               alignItems: 'center',
// // // //             }}
// // // //           >
// // // //             <Typography variant="h4" sx={{ mb: 2, color: "#2c2143" }}>
// // // //               {otpMode ? "OTP Login" : "User Login"}
// // // //             </Typography>
// // // //             <Typography variant="subtitle1" sx={{ mb: 1 }}>
// // // //               {otpMode
// // // //                 ? "Please enter your registered email to receive OTP."
// // // //                 : "Welcome back! Please enter your details."}
// // // //             </Typography>
// // // //             <Box component="form" noValidate onSubmit={handleSubmit} sx={{ mt: 2 }}>
// // // //               {!otpMode && (
// // // //                 <TextField
// // // //                   margin="normal"
// // // //                   required
// // // //                   fullWidth
// // // //                   id="email"
// // // //                   label="Enter your email"
// // // //                   name="email"
// // // //                   autoComplete="email"
// // // //                   autoFocus
// // // //                   error={emailError}
// // // //                   helperText={emailError && 'Email is required'}
// // // //                   value={email}
// // // //                   onChange={(e) => setEmail(e.target.value)}
// // // //                 />
// // // //               )}
// // // //               {!otpMode && (
// // // //                 <TextField
// // // //                   margin="normal"
// // // //                   required
// // // //                   fullWidth
// // // //                   name="password"
// // // //                   label="Password"
// // // //                   type={toggle ? 'text' : 'password'}
// // // //                   id="password"
// // // //                   autoComplete="current-password"
// // // //                   error={passwordError}
// // // //                   helperText={passwordError && 'Password is required'}
// // // //                   value={password}
// // // //                   onChange={(e) => setPassword(e.target.value)}
// // // //                   InputProps={{
// // // //                     endAdornment: (
// // // //                       <InputAdornment position="end">
// // // //                         <IconButton onClick={toggleVisibility}>
// // // //                           {toggle ? <Visibility /> : <VisibilityOff />}
// // // //                         </IconButton>
// // // //                       </InputAdornment>
// // // //                     ),
// // // //                   }}
// // // //                 />
// // // //               )}

// // // //               {!otpMode && (
// // // //                 <Grid container sx={{ display: "flex", justifyContent: "space-between" }}>
// // // //                   <FormControlLabel
// // // //                     control={<Checkbox value="remember" color="primary" />}
// // // //                     label="Remember me"
// // // //                   />
// // // //                   <StyledLink to="#" onClick={() => setForgotPasswordOpen(true)}>
// // // //                     Forgot your password?
// // // //                   </StyledLink>
// // // //                 </Grid>
// // // //               )}

// // // //               {otpMode && (
// // // //                 <TextField
// // // //                   margin="normal"
// // // //                   required
// // // //                   fullWidth
// // // //                   id="emailForOtp"
// // // //                   label="Enter your registered email"
// // // //                   name="emailForOtp"
// // // //                   autoComplete="email"
// // // //                   autoFocus
// // // //                   error={emailError}
// // // //                   helperText={emailError && 'Email is required'}
// // // //                   value={email}
// // // //                   onChange={(e) => setEmail(e.target.value)}
// // // //                 />
// // // //               )}
// // // //               {otpMode && (
// // // //                 <LightPurpleButton
// // // //                   fullWidth
// // // //                   variant="contained"
// // // //                   sx={{ mt: 2 }}
// // // //                   onClick={handleSubmit}
// // // //                 >
// // // //                   Send OTP
// // // //                 </LightPurpleButton>
// // // //               )}
// // // //               {!otpMode && (
// // // //                 <LightPurpleButton
// // // //                   type="submit"
// // // //                   fullWidth
// // // //                   variant="contained"
// // // //                   sx={{ mt: 3 }}
// // // //                 >
// // // //                   Login
// // // //                 </LightPurpleButton>
// // // //               )}
// // // //               {!otpMode && (
// // // //                 <Grid container sx={{ display: "flex", justifyContent: "space-between", marginTop: "7px" }}>
// // // //                   <StyledLink to="#" onClick={switchToOTPMode}>
// // // //                     Try another way to login?
// // // //                   </StyledLink>
// // // //                 </Grid>
// // // //               )}
// // // //             </Box>
// // // //           </Box>
// // // //         </Grid>
// // // //         <Grid
// // // //           item
// // // //           xs={false}
// // // //           sm={4}
// // // //           md={7}
// // // //           sx={{
// // // //             backgroundImage: `url(${bgpic})`,
// // // //             backgroundRepeat: 'no-repeat',
// // // //             backgroundColor: (t) =>
// // // //               t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
// // // //             backgroundSize: 'cover',
// // // //             backgroundPosition: 'center',
// // // //           }}
// // // //         />
// // // //       </Grid>

// // // //       {/* Forgot Password Dialog */}
// // // //       <Dialog open={forgotPasswordOpen} onClose={() => setForgotPasswordOpen(false)}>
// // // //         <DialogTitle>Forgot Password</DialogTitle>
// // // //         <DialogContent>
// // // //           <TextField
// // // //             autoFocus
// // // //             margin="dense"
// // // //             label="Email"
// // // //             type="email"
// // // //             fullWidth
// // // //             variant="outlined"
// // // //             value={forgotPasswordEmail}
// // // //             onChange={(e) => setForgotPasswordEmail(e.target.value)}
// // // //             error={emailError}
// // // //             helperText={emailError && 'Email is required'}
// // // //           />
// // // //           <FormControl fullWidth variant="outlined" margin="dense">
// // // //             <InputLabel>User Type</InputLabel>
// // // //             <Select
// // // //               value={userType}
// // // //               onChange={(e) => setUserType(e.target.value)}
// // // //               label="User Type"
// // // //             >
// // // //               <MenuItem value="">
// // // //                 <em>Select User Type</em>
// // // //               </MenuItem>
// // // //               <MenuItem value="student">Student</MenuItem>
// // // //               <MenuItem value="faculty">Faculty</MenuItem>
// // // //               <MenuItem value="staff">Staff</MenuItem>
// // // //               <MenuItem value="admin">Admin</MenuItem>
              
// // // //             </Select>
// // // //           </FormControl>
// // // //         </DialogContent>
// // // //         <DialogActions sx={{ justifyContent: 'center', padding: '16px' }}>
// // // //           <Button
// // // //             onClick={() => setForgotPasswordOpen(false)}
// // // //             color="error"
// // // //             variant="contained"
// // // //             sx={{
// // // //               mr: 1,
// // // //               bgcolor: 'red',
// // // //               '&:hover': {
// // // //                 bgcolor: 'darkred',
// // // //               },
// // // //               textTransform: 'none', // Prevent text from transforming to uppercase
// // // //             }}
// // // //           >
// // // //             Cancel
// // // //           </Button>
// // // //           <Button
// // // //             onClick={handleForgotPassword}
// // // //             variant="contained"
// // // //             sx={{
// // // //               bgcolor: 'primary.main',
// // // //               '&:hover': {
// // // //                 bgcolor: 'primary.dark',
// // // //               },
// // // //               textTransform: 'none', // Prevent text from transforming to uppercase
// // // //             }}
// // // //           >
// // // //             Send Reset Link
// // // //           </Button>
// // // //         </DialogActions>
// // // //       </Dialog>

// // // //     </ThemeProvider>
// // // //   );
// // // // };

// // // // export default LoginPage;


// // // // src/pages/LoginPage.jsx

// // // import React, { useState, useEffect } from "react";

// // // const LoginPage = ({ school }) => {
// // //   const [role, setRole] = useState("admin"); // "admin" or "user"
// // //   const [form, setForm] = useState({ email: "", password: "" });

// // //   useEffect(() => {
// // //     document.title = `${school?.name || "School"} | Login`;
// // //   }, [school]);

// // //   const handleChange = (e) => {
// // //     setForm({ ...form, [e.target.name]: e.target.value });
// // //   };

// // //   const handleSubmit = (e) => {
// // //     e.preventDefault();
// // //     console.log(`Logging in as ${role}`, form);
// // //     // TODO: Handle login API call based on role
// // //   };

// // //   return (
// // //     <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-blue-100 to-blue-300 p-4">
// // //       <div className="w-full max-w-4xl bg-white rounded-2xl shadow-xl overflow-hidden grid md:grid-cols-2">
// // //         {/* Left Panel - Branding */}
// // //         <div className="hidden md:flex flex-col justify-center items-center bg-blue-700 text-white p-10">
// // //           {school?.logo && (
// // //             <img src={school.logo} alt="Logo" className="h-20 mb-4 rounded-md" />
// // //           )}
// // //           <h2 className="text-3xl font-bold mb-2">{school?.name || "Your School"}</h2>
// // //           <p className="text-blue-100 text-center text-sm">
// // //             {school?.tagline || "Welcome to your ERP portal. Login to continue."}
// // //           </p>
// // //         </div>

// // //         {/* Right Panel - Login Form */}
// // //         <div className="w-full p-8 sm:p-10">
// // //           <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">Welcome Back</h2>

// // //           {/* Role Switcher */}
// // //           <div className="flex justify-center gap-4 mb-6">
// // //             <button
// // //               onClick={() => setRole("admin")}
// // //               className={`px-4 py-2 rounded-full font-medium transition ${
// // //                 role === "admin"
// // //                   ? "bg-blue-600 text-white"
// // //                   : "bg-gray-100 text-gray-600 hover:bg-gray-200"
// // //               }`}
// // //             >
// // //               Admin (Owner)
// // //             </button>
// // //             <button
// // //               onClick={() => setRole("user")}
// // //               className={`px-4 py-2 rounded-full font-medium transition ${
// // //                 role === "user"
// // //                   ? "bg-blue-600 text-white"
// // //                   : "bg-gray-100 text-gray-600 hover:bg-gray-200"
// // //               }`}
// // //             >
// // //               Staff / Student / Others
// // //             </button>
// // //           </div>

// // //           <form onSubmit={handleSubmit} className="space-y-5">
// // //             {/* Email or Username */}
// // //             <div>
// // //               <label className="block text-sm font-medium text-gray-700">
// // //                 {role === "admin" ? "Admin Email" : "Username or Email"}
// // //               </label>
// // //               <input
// // //                 type="text"
// // //                 name="email"
// // //                 required
// // //                 onChange={handleChange}
// // //                 className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
// // //               />
// // //             </div>

// // //             {/* Password */}
// // //             <div>
// // //               <label className="block text-sm font-medium text-gray-700">Password</label>
// // //               <input
// // //                 type="password"
// // //                 name="password"
// // //                 required
// // //                 onChange={handleChange}
// // //                 className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
// // //               />
// // //             </div>

// // //             {/* Optional: Role-based extra field (e.g., ID or Code) */}
// // //             {role === "user" && (
// // //               <div>
// // //                 <label className="block text-sm font-medium text-gray-700">
// // //                   Registration Code <span className="text-gray-400 text-xs">(if any)</span>
// // //                 </label>
// // //                 <input
// // //                   type="text"
// // //                   name="code"
// // //                   onChange={handleChange}
// // //                   className="w-full mt-1 px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
// // //                 />
// // //               </div>
// // //             )}

// // //             <button
// // //               type="submit"
// // //               className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition font-semibold"
// // //             >
// // //               Login as {role === "admin" ? "Admin" : "User"}
// // //             </button>
// // //           </form>

// // //           {/* Footer links */}
// // //           <div className="text-center mt-6 text-sm text-gray-500">
// // //             <a href="/forgot-password" className="hover:underline">Forgot Password?</a>
// // //           </div>
// // //         </div>
// // //       </div>
// // //     </div>
// // //   );
// // // };

// // // export default LoginPage;



// // import React, { useState, useEffect } from "react";

// // const LoginPage = ({ school }) => {
// //   const [role, setRole] = useState(null);
// //   const [form, setForm] = useState({ email: "", password: "", code: "" });

// //   useEffect(() => {
// //     document.title = `${school?.name || "School"} | Login`;
// //   }, [school]);

// //   const handleChange = (e) => {
// //     setForm({ ...form, [e.target.name]: e.target.value });
// //   };

// //   const handleSubmit = (e) => {
// //     e.preventDefault();
// //     console.log(`Logging in as ${role}`, form);
// //     // TODO: Handle login API call
// //   };

// //   return (
// //     <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-blue-100 to-blue-300 p-4">
// //       <div className="w-full max-w-5xl bg-white rounded-2xl shadow-lg overflow-hidden flex flex-col md:flex-row">
// //         {/* Left Panel */}
// //         <div className="hidden md:flex w-full md:w-1/2 bg-blue-700 text-white flex-col justify-center items-center px-10 py-12 text-center">
// //           {school?.logo && (
// //             <img
// //               src={school.logo}
// //               alt="Logo"
// //               className="h-20 mb-6 rounded-md shadow-lg"
// //             />
// //           )}
// //           <h2 className="text-3xl font-bold mb-4">{school?.name || "Your School"}</h2>
// //           <p className="text-white-100 text-base leading-relaxed max-w-md">
           
// //             Log in now to access your personalized dashboard, view assignments, track performance, and connect with your institution.
// //             <br />
// //             Let’s get started!
// //           </p>
// //         </div>

// //         {/* Right Panel */}
// //         <div className="w-full md:w-1/2 p-8 sm:p-12 flex flex-col justify-center">
// //           <h2 className="text-2xl font-bold text-gray-800 mb-3 text-center">
// //             Welcome to {school?.name || "School ERP Portal"}
// //           </h2>

// //           {!role ? (
// //             <>
// //               <p className="text-center text-gray-600 mb-6">
// //                 Please choose how you'd like to log in:
// //               </p>
// //               <div className="flex flex-col gap-6 bg-gray-50 p-4 rounded-md">
// //                 {/* User Login First */}
// //                 <div>
// //                   <button
// //                     onClick={() => setRole("user")}
// //                     className="w-full bg-gray-100 text-gray-800 py-3 rounded-lg font-medium hover:bg-gray-200 transition"
// //                   >
// //                     I am a Student / Teacher / Staff / Assistant
// //                   </button>
// //                   <p className="text-center text-sm text-gray-500 mt-1">
// //                     For academic access: timetable, grades, tasks, and more.
// //                   </p>
// //                 </div>

// //                 {/* Admin Login Second */}
// //                 <div>
// //                   <button
// //                     onClick={() => setRole("admin")}
// //                     className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition"
// //                   >
// //                     I am a School Owner
// //                   </button>
// //                   <p className="text-center text-sm text-gray-100 mt-1 bg-blue-600 py-1 rounded-md">
// //                     Access school-wide configurations, users, and reports.
// //                   </p>
// //                 </div>
// //               </div>
// //             </>
// //           ) : (
// //             <>
// //               <button
// //                 onClick={() => setRole(null)}
// //                 className="mb-4 text-blue-500 hover:underline text-sm"
// //               >
// //                 ← Change Login Type
// //               </button>

// //               <h3 className="text-xl font-semibold text-center text-gray-700 mb-6">
// //                 Login as {role === "admin" ? "School Owner / Admin" : "Staff / Student / Others"}
// //               </h3>

// //               <form onSubmit={handleSubmit} className="space-y-5">
// //                 <div>
// //                   <label className="block text-sm font-medium text-gray-700 mb-1">
// //                     {role === "admin" ? "Admin Email" : "Username or Email"}
// //                   </label>
// //                   <input
// //                     type="text"
// //                     name="email"
// //                     required
// //                     placeholder={
// //                       role === "admin"
// //                         ? "e.g. owner@schoolname.com"
// //                         : "e.g. student123 or student@school.com"
// //                     }
// //                     onChange={handleChange}
// //                     className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
// //                   />
// //                 </div>

// //                 <div>
// //                   <label className="block text-sm font-medium text-gray-700 mb-1">
// //                     Password
// //                   </label>
// //                   <input
// //                     type="password"
// //                     name="password"
// //                     required
// //                     placeholder="Enter your password"
// //                     onChange={handleChange}
// //                     className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
// //                   />
// //                 </div>

// //                 {role === "user" && (
// //                   <div>
// //                     <label className="block text-sm font-medium text-gray-700 mb-1">
// //                       Registration Code{" "}
// //                       <span className="text-gray-400 text-xs">(optional)</span>
// //                     </label>
// //                     <input
// //                       type="text"
// //                       name="code"
// //                       placeholder="Enter code if provided"
// //                       onChange={handleChange}
// //                       className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
// //                     />
// //                   </div>
// //                 )}

// //                 <button
// //                   type="submit"
// //                   className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition font-semibold"
// //                 >
// //                   Login
// //                 </button>
// //               </form>

// //               <div className="text-center mt-6 text-sm text-gray-500">
// //                 <a href="/forgot-password" className="hover:underline">
// //                   Forgot Password?
// //                 </a>
// //               </div>
// //             </>
// //           )}
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default LoginPage;

// import React, { useState, useEffect } from "react";

// const LoginPage = ({ school }) => {
//   const [role, setRole] = useState(null);
//   const [form, setForm] = useState({ email: "", password: "", code: "" });

//   useEffect(() => {
//     document.title = `${school?.name || "School"} | Login`;
//   }, [school]);

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     console.log(`Logging in as ${role}`, form);
//     // TODO: Handle login API call
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-blue-100 to-blue-300 p-4">
//       <div className="w-full max-w-5xl bg-white rounded-2xl shadow-lg overflow-hidden flex flex-col md:flex-row">
//         {/* Left Panel */}
//         <div className="hidden md:flex w-full md:w-1/2 bg-blue-700 text-white flex-col justify-center items-center px-10 py-12 text-center">
//           {school?.logo && (
//             <img
//               src={school.logo}
//               alt="Logo"
//               className="h-20 mb-6 rounded-md shadow-lg"
//             />
//           )}
//           <h2 className="text-3xl font-bold mb-4">
//             {school?.name || "Login"}
//           </h2>
//           <p className="text-white text-base leading-relaxed max-w-md">
//             Log in to access your dashboard, view assignments, track performance, and stay connected with your school.
//             <br />
//             Start your journey now!
//           </p>
//         </div>

//         {/* Right Panel */}
//         <div className="w-full md:w-1/2 p-8 sm:p-12 flex flex-col justify-center relative">
//           {/* Change Login Type */}
//           {role && (
//             <button
//               onClick={() => setRole(null)}
//               className="absolute top-4 left-4 text-blue-500 hover:underline text-sm"
//             >
//               ← Change Login Type
//             </button>
//           )}

//           <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
//             Welcome to {school?.name || "School ERP Portal"}
//           </h2>

//           {!role ? (
//             <>
//               <p className="text-center text-gray-600 mb-6">
//                 Please choose how you'd like to log in:
//               </p>

//               <div className="space-y-4">
//                 {/* Login Options as Styled Buttons */}
//                 <div
//                   onClick={() => setRole("user")}
//                   className="cursor-pointer border border-gray-300 hover:border-blue-500 rounded-md p-4 transition bg-white shadow-sm hover:shadow-md relative group"
//                 >
//                   <div className="flex items-center justify-between">
//                     <h4 className="text-lg font-medium text-gray-800">
//                       Student / Teacher / Staff / Assistant
//                     </h4>
//                     <span className="text-sm text-blue-500 group-hover:underline">
//                       Select
//                     </span>
//                   </div>
//                   <p className="text-sm text-gray-500 mt-1 hidden group-hover:block">
//                     Use this option to access classes, grades, tasks, and more.
//                   </p>
//                 </div>

//                 <div
//                   onClick={() => setRole("admin")}
//                   className="cursor-pointer border border-gray-300 hover:border-blue-600 rounded-md p-4 transition bg-white shadow-sm hover:shadow-md relative group"
//                 >
//                   <div className="flex items-center justify-between">
//                     <h4 className="text-lg font-medium text-gray-800">
//                       School Owner / Admin
//                     </h4>
//                     <span className="text-sm text-blue-500 group-hover:underline">
//                       Select
//                     </span>
//                   </div>
//                   <p className="text-sm text-gray-500 mt-1 hidden group-hover:block">
//                     Use this option to manage the school system, settings, and user roles.
//                   </p>
//                 </div>
//               </div>
//             </>
//           ) : (
//             <>
//               <h3 className="text-xl font-semibold text-center text-gray-700 mb-6 mt-8">
//                 Login as {role === "admin" ? "School Owner / Admin" : "Staff / Student / Others"}
//               </h3>

//               <form onSubmit={handleSubmit} className="space-y-5">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     {role === "admin" ? "Admin Email" : "Username or Email"}
//                   </label>
//                   <input
//                     type="text"
//                     name="email"
//                     required
//                     placeholder={
//                       role === "admin"
//                         ? "e.g. owner@schoolname.com"
//                         : "e.g. student123 or student@school.com"
//                     }
//                     onChange={handleChange}
//                     className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Password
//                   </label>
//                   <input
//                     type="password"
//                     name="password"
//                     required
//                     placeholder="Enter your password"
//                     onChange={handleChange}
//                     className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
//                   />
//                 </div>

//                 {role === "user" && (
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Registration Code{" "}
//                       <span className="text-gray-400 text-xs">(optional)</span>
//                     </label>
//                     <input
//                       type="text"
//                       name="code"
//                       placeholder="Enter code if provided"
//                       onChange={handleChange}
//                       className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
//                     />
//                   </div>
//                 )}

//                 <button
//                   type="submit"
//                   className="w-full bg-blue-600 text-white py-2 rounded-md hover:bg-blue-700 transition font-semibold"
//                 >
//                   Login
//                 </button>
//               </form>

//               <div className="text-center mt-6 text-sm text-gray-500">
//                 <a href="/forgot-password" className="hover:underline">
//                   Forgot Password?
//                 </a>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;




// import React, { useState, useEffect, useContext } from "react";
// import { useNavigate } from "react-router-dom";
// import { AuthContext } from "./context/AuthContext";
// import axios from "axios";

// const LoginPage = ({ school }) => {

//   const {setIsLoggedIn} = useContext(AuthContext);

//   const navigate = useNavigate();
//   const [role, setRole] = useState(null);
//   const [form, setForm] = useState({ email: "", password: "", code: "" });
//   const [loading, setLoading] = useState(false);

//   const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

//   useEffect(() => {
//     document.title = `${school?.name || "School"} | Login`;
//   }, [school]);

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     const endpoint =
//     role === "owner"
//     ? `${BACKEND_URL}/api/v1/schoolLogin`
//     : `${BACKEND_URL}/api/v1/usersLogin`;

//     try {
//       const response = await axios.post(
//         endpoint,
//         {
//           email: form.email,
//           password: form.password,
//         },
//         { withCredentials: true }
//       );

//       if (response.data.success) {
//         const user = response.data.user;

//         setIsLoggedIn(true);

//         if (role === "owner") {
//           navigate("/Adminstrator/dashboard");
//         } else {
//           // Redirect based on userType
//           switch (user.userType) {
//             case "admin":
//               navigate("/Admin/dashboard");
//               break;
//             case "student":
//               navigate("/StudentDashboard");
//               break;
//             case "faculty":
//               navigate("/FacultyDashboard");
//               break;
//             case "staff":
//               navigate("/StaffDashboard");
//               break;
//             default:
//               alert("Unknown user type");
//           }
//         }
//       } else {
//         alert(response.data.message || "Login failed");
//       }
//     } catch (error) {
//       console.error(error);
//       alert(
//         error.response?.data?.message || "An error occurred during login"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-blue-100 to-blue-300 p-4">
//       <div className="w-full max-w-5xl bg-white rounded-2xl shadow-lg overflow-hidden flex flex-col md:flex-row">
//         {/* Left Panel */}
//         <div className="hidden md:flex w-full md:w-1/2 bg-blue-700 text-white flex-col justify-center items-center px-10 py-12 text-center">
//           {school?.logo && (
//             <img
//               src={school.logo}
//               alt="Logo"
//               className="h-20 mb-6 rounded-md shadow-lg"
//             />
//           )}
//           <h2 className="text-3xl font-bold mb-4">
//             {school?.name || "Login"}
//           </h2>
//           <p className="text-white text-base leading-relaxed max-w-md">
//             Log in to access your dashboard, view assignments, track performance, and stay connected with your school.
//             <br />
//             Start your journey now!
//           </p>
//         </div>

//         {/* Right Panel */}
//         <div className="w-full md:w-1/2 p-8 sm:p-12 flex flex-col justify-center relative">
//           {/* Change Login Type */}
//           {role && (
//             <button
//               onClick={() => setRole(null)}
//               className="absolute top-4 left-4 text-blue-500 hover:underline text-sm"
//             >
//               ← Change Login Type
//             </button>
//           )}

//           <h2 className="text-2xl font-bold text-gray-800 mb-6 text-center">
//             Welcome to {school?.name || "School ERP Portal"}
//           </h2>

//           {!role ? (
//             <>
//               <p className="text-center text-gray-600 mb-6">
//                 Please choose how you'd like to log in:
//               </p>

//               <div className="space-y-4">
//                 {/* Student/Staff/Faculty */}
//                 <div
//                   onClick={() => setRole("user")}
//                   className="cursor-pointer border border-gray-300 hover:border-blue-500 rounded-md p-4 transition bg-white shadow-sm hover:shadow-md relative group"
//                 >
//                   <div className="flex items-center justify-between">
//                     <h4 className="text-lg font-medium text-gray-800">
//                       Student / Teacher / Staff / Assistant
//                     </h4>
//                     <span className="text-sm text-blue-500 group-hover:underline">
//                       Select
//                     </span>
//                   </div>
//                   <p className="text-sm text-gray-500 mt-1 hidden group-hover:block">
//                     Use this option to access classes, grades, tasks, and more.
//                   </p>
//                 </div>

//                 {/* School Owner / Admin */}
//                 <div
//                   onClick={() => setRole("owner")}
//                   className="cursor-pointer border border-gray-300 hover:border-blue-600 rounded-md p-4 transition bg-white shadow-sm hover:shadow-md relative group"
//                 >
//                   <div className="flex items-center justify-between">
//                     <h4 className="text-lg font-medium text-gray-800">
//                       Adminstrator
//                     </h4>
//                     <span className="text-sm text-blue-500 group-hover:underline">
//                       Select
//                     </span>
//                   </div>
//                   <p className="text-sm text-gray-500 mt-1 hidden group-hover:block">
//                     Use this option to manage the school system, settings, and user roles.
//                   </p>
//                 </div>
//               </div>
//             </>
//           ) : (
//             <>
//               <h3 className="text-xl font-semibold text-center text-gray-700 mb-6 mt-8">
//                 Login as {role === "owner" ? "Adminstrator" : "Staff / Student / Others"}
//               </h3>

//               <form onSubmit={handleSubmit} className="space-y-5">
//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     {role === "owner" ? "Adminstrator Email" : "Username or Email"}
//                   </label>
//                   <input
//                     type="text"
//                     name="email"
//                     required
//                     placeholder={
//                       role === "owner"
//                         ? "e.g. adminstrator@schoolname.com"
//                         : "e.g. student123 or student@school.com"
//                     }
//                     onChange={handleChange}
//                     className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-gray-700 mb-1">
//                     Password
//                   </label>
//                   <input
//                     type="password"
//                     name="password"
//                     required
//                     placeholder="Enter your password"
//                     onChange={handleChange}
//                     className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
//                   />
//                 </div>

//                 {/* {role === "user" && (
//                   <div>
//                     <label className="block text-sm font-medium text-gray-700 mb-1">
//                       Registration Code{" "}
//                       <span className="text-gray-400 text-xs">(optional)</span>
//                     </label>
//                     <input
//                       type="text"
//                       name="code"
//                       placeholder="Enter code if provided"
//                       onChange={handleChange}
//                       className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
//                     />
//                   </div>
//                 )} */}

//                 <button
//                   type="submit"
//                   disabled={loading}
//                   className={`w-full ${
//                     loading ? "bg-blue-400" : "bg-blue-600 hover:bg-blue-700"
//                   } text-white py-2 rounded-md transition font-semibold`}
//                 >
//                   {loading ? "Logging in..." : "Login"}
//                 </button>
//               </form>

//               <div className="text-center mt-6 text-sm text-gray-500">
//                 <a href="/forgot-password" className="hover:underline">
//                   Forgot Password?
//                 </a>
//               </div>
//             </>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default LoginPage;

import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { login } from '../features/auth/authSlice'; // ✅ correct import

const LoginPage = ({ school }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [role, setRole] = useState(null);
  const [form, setForm] = useState({ email: "", password: "" });

  const { isAuthenticated, user, role: authRole, loading, error } = useSelector(
    (state) => state.auth
  );

  console.log("user detail:", user);
  console.log("userType:", user?.userType);
  console.log("isAuthenticated:", isAuthenticated);
  console.log("authRole:", authRole);
  

  useEffect(() => {
    document.title = `${school?.name || "School"} | Login`;
  }, [school]);

  // Navigate when logged in
  useEffect(() => {
    if (isAuthenticated) {
      if (authRole === "owner") {
        navigate("/Adminstrator/dashboard");
      } else {
        switch (user?.userType) {
          case "admin":
            navigate("/Admin/dashboard");
            break;
          case "student":
            navigate("/StudentDashboard");
            break;
          case "faculty":
            navigate("/FacultyDashboard");
            break;
          case "staff":
            navigate("/StaffDashboard");
            break;
          default:
            alert("Unknown user type");
        }
      }
    }
  }, [isAuthenticated, user, authRole, navigate]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!role) {
      return alert("Please select login type");
    }

    dispatch(login({ email: form.email, password: form.password, role }));
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-tr from-blue-100 to-blue-300 p-4">
      <div className="w-full max-w-5xl bg-white rounded-2xl shadow-lg overflow-hidden flex flex-col md:flex-row">
        {/* Left Panel */}
        <div className="hidden md:flex w-full md:w-1/2 bg-blue-700 text-white flex-col justify-center items-center px-10 py-12 text-center">
          {school?.logo && (
            <img
              src={school.logo}
              alt="Logo"
              className="h-20 mb-6 rounded-md shadow-lg"
            />
          )}
          <h2 className="text-3xl font-bold mb-4">
            {school?.name || "Login"}
          </h2>
          <p className="text-white text-base leading-relaxed max-w-md">
            Log in to access your dashboard, view assignments, track performance,
            and stay connected with your school. <br />
            Start your journey now!
          </p>
        </div>

        {/* Right Panel */}
        <div className="w-full md:w-1/2 p-8 sm:p-12 flex flex-col justify-center relative">
          {role && (
            <button
              onClick={() => setRole(null)}
              className="absolute top-4 left-4 text-blue-500 hover:underline text-sm"
            >
              ← Change Login Type
            </button>
          )}

          <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
            Welcome to {school?.name || "School ERP Portal"}
          </h2>

          {!role ? (
            <>
              <p className="text-center text-gray-600 mb-4">
                Please choose how you'd like to log in:
              </p>

              <div className="space-y-4">
                <div
                  onClick={() => setRole("user")}
                  className="cursor-pointer border border-gray-300 hover:border-blue-500 rounded-md p-4 transition bg-white shadow-sm hover:shadow-md relative group"
                >
                  <div className="flex items-center justify-between">
                    <h4 className="text-lg font-medium text-gray-800">
                      Sign in as Student / Teacher / Staff / Assistant
                    </h4>
                    {/* <span className="text-sm text-blue-500 group-hover:underline">
                      Select
                    </span> */}
                  </div>
                  <p className="text-sm text-gray-500 mt-1 hidden group-hover:block">
                    Use this option to access classes, grades, tasks, and more.
                  </p>
                </div>

                <div
                  onClick={() => setRole("owner")}
                  className="cursor-pointer border border-gray-300 hover:border-blue-600 rounded-md p-4 transition bg-white shadow-sm hover:shadow-md relative group"
                >
                  <div className="flex items-center justify-between">
                    <h4 className="text-lg font-medium text-gray-800">
                      Sign in as Administrator
                    </h4>
                    {/* <span className="text-sm text-blue-500 group-hover:underline">
                      Select
                    </span> */}
                  </div>
                  <p className="text-sm text-gray-500 mt-1 hidden group-hover:block">
                    Use this option to manage the school system and settings.
                  </p>
                </div>
              </div>
            </>
          ) : (
            <>
              <h3 className="text-xl font-semibold text-center text-gray-700 mb-6 mt-8">
                Login as {role === "owner" ? "Administrator" : "Staff / Student / Others"}
              </h3>

              <form onSubmit={handleSubmit} className="space-y-5">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    {role === "owner" ? "Administrator Email" : "Username or Email"}
                  </label>
                  <input
                    type="text"
                    name="email"
                    required
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
                    placeholder={
                      role === "owner"
                        ? "e.g. admin@schoolname.com"
                        : "e.g. student123 or student@school.com"
                    }
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Password
                  </label>
                  <input
                    type="password"
                    name="password"
                    required
                    onChange={handleChange}
                    className="w-full px-4 py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400 focus:outline-none"
                    placeholder="Enter your password"
                  />
                </div>

                {error && (
                  <p className="text-sm text-red-600 text-center">{error}</p>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className={`w-full ${
                    loading ? "bg-blue-400" : "bg-blue-600 hover:bg-blue-700"
                  } text-white py-2 rounded-md transition font-semibold`}
                >
                  {loading ? "Logging in..." : "Login"}
                </button>
              </form>

              <div className="text-center mt-6 text-sm text-gray-500">
                <a href="/forgot-password" className="hover:underline">
                  Forgot Password?
                </a>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
